<template>
  <div id="main">
    <div class="alert-bg" v-if="alert.show">
      <div class="alert-content">
        <h3>{{$t('default.Notice')}}</h3>
        <p>{{alert.content}}</p>
        <a href="javascript:;" @click="alert.show = false">{{$t('default.Done')}}</a>
      </div>
    </div>
    <router-view/>
  </div>
</template>
<script>
import WdButton from '@/components/WdButton.vue';

export default {
  name: 'app',
  data(){
    return {
      alert:{
        content:'',
        show:false
      },
    }
  },
  components:{
      'wd-button':WdButton
  },
  methods: {

  },
  async created(){
    if(this.$route.path == '/login'){
      this.$router.push('/');
    }
    this.alert.show = false;
    this.$events.listen('SHOW-ALERT',(content)=>{
      if(this.alert.show == true) return;
      this.alert = {
        show:true,
        content:content
      }
    })
  }
}
</script>
<style>
html,body{
  width: 100%;
  height: 100%;
  font-family: "微软雅黑","\5b8b\4f53",Arial,sans-serif;
}
body,p,ul,li{
  padding: 0;
  margin: 0;
}
img{
  border: none;
}
ul li{
  list-style: none;
}
em,i{font-style: normal;}
a{text-decoration: none; color: #666}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  padding-left: 260px;
}
#main{
  width: 100%;
  height: 100%;
}
#nav{
  position: fixed;
  background-color: #232428;
  width: 260px;
  top: 0;
  left: 0;
  bottom: 0;
  overflow: hidden;
}

#header{
  height: 85px;
  background-color: #151515;
  width: 100%;
  color:#fff;
}
#header a{
  color: #fff;
}


#no-auth-app #header{
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  background:transparent;
  z-index: 998
}

#nav .logo{
  display: block;
  text-align: center;
  padding-top: 30px;
  margin-bottom: 50px;
}

#nav .logo img{
  width: 80px;
}

#nav .menu-container{
  text-align: center;
  color: #8b8b8b;
}
#nav .menu-container b{
  display: block;
  background-image: url(./assets/nav-menu-1.png);
  background-repeat: no-repeat;
  background-position: center 15px;
  -webkit-background-size: 40px auto;
  background-size: 40px auto;
  padding-top: 60px;
  padding-bottom: 15px;
  color: #fff;
  cursor: pointer;
}
#nav .menu-container.menu-1 b{
  background-image: url(./assets/nav-menu-2.png);
}
#nav .menu-container.menu-2 b{
  background-image: url(./assets/nav-menu-3.png);
}
#nav .menu-container b:hover,#nav .menu-container b.active{
  background-color: #c72729;
}
#nav .menu-container a{
  display: block;
  padding: 18px;
  text-align: center;
  color: #f3f3f3
}

#nav .menu-container a.active{
  border-left:3px solid #c72729;
  background-color: #151515;
  color: #fff;
}
#nav .menu-container a:hover{
  color: #fff
}

#header ul{
  float:right;
  height: 100%;
}
#header ul li{
  height: 85px;
  font-size: 15px;
  padding: 0 20px;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  position: relative;
}
#header ul li.header-link{
  width: 120px;
  font-weight: 600;
  line-height: 18px;
  padding: 0px;
}
#header ul li.header-link a{
  display: flex;
  width: 100%;
  height: 85px;
  justify-content: center;
  align-items: center;
  padding: 0px 20px;
  box-sizing: border-box;
  /*line-height: 85px;*/

}
#header ul li.subs{
  cursor: pointer;
}
#header ul li.header-lans b{
  font-size: 14px;
  font-weight: normal;
  text-decoration: underline;
}
#header .sub-content{
  display: none;
  position: absolute;
  top: 85px;
  right: 0;
  left:0;
  background-color: #c72729;
  color: #fff;
  z-index: 999
}


#header ul li.subs:hover .sub-content{
  display: block
}
#header .sub-content a{
  display: block;
  padding: 20px 0px;
  border-top: 1px solid #dc797a;
}
#header li:hover{
  background-color: #c72729;
  color: #fff;
}
#header .subs:hover b{
  color: #fff;
}
#header .subs:hover b:after{
  border-top: 7px solid #fff;
}
#header .header-games b{
  color:#c72729;
  position: relative;
  padding-right: 20px;
}
#header .header-games b:after{
  position: absolute;
  content:'';
  top: 7px;
  right: 0;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 7px solid #c72729;
}
#header .header-lans{
  width: 100px;
  box-sizing: border-box;
  padding: 0;
}
#header .header-account{
  color: #8b8b8b;
}
#header .header-account b{
  color: #fff;
  margin-right: 5px;
}
#header .header-account a{
  color:#8b8b8b;
  margin-left: 5px;
}
#header .header-account a:hover{
  color:#fff;
}
#header .header-account:hover{
  background-color: #151515;
  color: #8b8b8b;
}
#breadcrumb{
  border-bottom: 1px solid #eaeaea;
  padding: 15px 20px;
  font-size: 14px;
  color: #666
}
#breadcrumb span{
  background-image: url(./assets/breadcrumb-icon.png);
  background-repeat: no-repeat;
  -webkit-background-size: 18px 18px;
  background-size: 18px 18px;
  padding-left: 30px;
}
#breadcrumb span i{
  color: #dedede;
  padding: 0 5px;
}

.form-container{
  width: 600px;
  margin: 0px auto;
}
.form-container h2{
  text-align: center;
}
.form-item{
  margin-bottom: 15px;
  height: 44px;
  display: flex;
  align-items: center;
}
.form-item label{
  width: 150px;
  display: inline-block;
  padding-right: 10px;
  text-align: right;
  font-size: 14px;
}
.form-item input{
  border: 1px solid #d5d5d5;
  padding: 8px 10px;
  border-radius: 3px;
  width: 300px;
  box-sizing: border-box;
  height: 44px;
  outline: none;
}
.form-item input:focus{
  border: 1px solid #999
}
.form-item input.error{
  border: 1px solid #c72729
}
.form-item select{
  height: 44px;
  border: 1px solid #d5d5d5;
  width: 300px;
}
.code-item .code-input{
  flex:1;
  margin-right: 10px;
}
.code-item label{
  width: 150px;
  flex-shrink: 0
}
.code-item .code-img{
  height: 44px;
  width: 100px;
}
.code-item{
  width: 460px;
  display: flex;
  align-items:center;
}

.text-danger{
  font-size: 24px;
  font-weight: 600;
  color: #c72729
}
.result-div{
  width: 500px;
  margin: 60px auto;
  text-align: center;
}
.result-div p{
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px 0;
}
.result-div p img{
  margin-right: 10px;
}
.result-div p b{
  margin-right: 10px;
}
.result-div p span{
  font-size: 18px;
  font-weight: bold;
}

.dialog-bg{
  background-color: rgba(0,0,0,.7);
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1000
}
.dialog-container{
  background-color: #fff;
  width: 550px;
  margin: 0px auto;
  margin-top: 150px;
  border-top: 8px solid #f2f2f2;
  position: relative;
  padding-top: 40px;
  padding-bottom: 40px;
}
.dialog-container .dialog-close-btn{
  background-image: url(./assets/close.png);
  position: absolute;
  right: 15px;
  top: 15px;
  width: 30px;
  height: 30px;
  background-repeat: no-repeat;
  -webkit-background-size: 100% auto;
  background-size: 100% auto;
}

.banner{
  position: absolute;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  background: url(./assets/login-bg.jpg) no-repeat;
  background-size: cover;
  background-position: center center;
}

.banner .banner-man {
    position: absolute;
    left: 30%;
    top: 287px;
    margin-left: -617px;
    width: 591px;
    height: 853px;
    z-index: 5;
}

.banner .banner-woman {
    position: absolute;
    width: 734px;
    height: 930px;
    left: 25%;
    margin-left: -335px;
    top: 150px;
    z-index: 5;
}
.no-auth-logo{
  position: absolute;
  z-index: 999;
  top: 40px;
  left: 50px;
}

.alert-bg{
  position: fixed;
  width: 100%;
  top: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0);
  z-index: 100000
}

.alert-bg .alert-content{
  position: absolute; 
  top: 100px;
  width: 400px;
  left: 50%;
  margin-left: -200px;
  background-color: rgba(0,0,0,.9);
  z-index: 100001;
  padding: 20px 30px;
  border-top:3px solid #c72729;
  /*box-shadow: 0px 0px 10px #000;*/
}
.alert-bg .alert-content h3{
  margin: 0px;
  margin-bottom: 10px;
  color: #fff;
}
.alert-bg .alert-content p{
  margin-bottom: 20px;
  color: #fff;
}
.alert-bg .alert-content a{
  float: right;
  color: #fff;
  background-color: #c72729;
  padding: 10px 30px;
}
.footer{
  position: absolute;
  bottom: 40px;
  left: 0;
  width: 100%;
}
.footer .foot-list{
  width: 100%;
  text-align: center;
  line-height: 22px;
  color: #ababab;
  font-size: 14px;
}
.footer .foot-list a{
  color: #ababab;
}
.footer .foot-list a:hover{
  color: #c72729;
}
.footer .foot-list .beian {
		width: 20px;
		height: 20px;
		display: inline-block;
		vertical-align: top;
		margin-right: 4px;
	}
</style>
